import { Component, Input, OnInit, DoCheck, ChangeDetectorRef } from "@angular/core";
import { SecurityConfig } from "../../../../edtell-admin/interfaces/route-security-config.interface";
import { EdtellTabConfig } from "../../../interface/edtell-tabset.config";

@Component({
  selector: "app-edtell-tab",
  templateUrl: "./edtell-tab.component.html",
  styleUrls: ["./edtell-tab.component.scss"],
})
export class EdtellTabComponent implements OnInit {
  @Input() title: string;

  _config: EdtellTabConfig;
  @Input() set config(value: EdtellTabConfig) {
    this._config = value;
    this.security = value.security;
  }
  get config(): EdtellTabConfig {
    return this._config;
  }

  security: SecurityConfig;

  _tabOpen = false;
  set tabOpen(value: boolean) {
    this._tabOpen = value;
    this.cd.detectChanges();
  }

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
  }
}
